(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[922],{

/***/ 83839:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/long-template-page",
      function () {
        return __webpack_require__(58850);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hamburger_menu_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.scss.js



var StyledHamburgerMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ajo1f0"
})("width:28px;transform:rotate(0deg);cursor:pointer;z-index:", z_index/* SIDE_NAV */.gR + 1, ";margin-left:24px;margin-right:8px;height:36px;display:flex;.hamburger-menu-line{display:block;position:absolute;height:3px;width:100%;background-color:", colors/* default.black */.Z.black, ";border-radius:4px;opacity:1;left:0;transform:rotate(0deg);transition:all 0.2s ease-in-out;&:nth-child(1){top:8px;}&:nth-child(2),&:nth-child(3){top:17px;}&:nth-child(4){top:26px;}}&.open{.hamburger-menu-line{background-color:", colors/* default.black */.Z.black, ";&:nth-child(1){top:18px;width:0%;left:50%;}&:nth-child(2){transform:rotate(45deg);}&:nth-child(3){transform:rotate(-45deg);}&:nth-child(4){top:18px;width:0;left:50%;}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js










var HamburgerMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HamburgerMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HamburgerMenuComponent);
    function HamburgerMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HamburgerMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.toggleOpenState = _this.toggleOpenState.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.toggleOpenState);
        return _this;
    }
    (0,_create_class/* default */.Z)(HamburgerMenuComponent, [
        {
            key: "toggleOpenState",
            value: function toggleOpenState() {
                var isOpen = this.props.isOpen;
                this.props.changeStateCallback(!isOpen);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, isOpen = _props.isOpen, translate = _props.translate;
                var scrollModeClass = isInScrollMode ? "scroll-mode" : "";
                var openMode = isOpen ? "open" : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamburgerMenuComponent, {
                    className: "hamburger-menu ".concat(theme, " ").concat(scrollModeClass, " ").concat(openMode),
                    tabIndex: 0,
                    onClick: this.toggleOpenState,
                    onKeyDown: this.onKeyDown,
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    "aria-label": isOpen ? translate("header.closeMenu") : translate("header.openMenu"),
                    "aria-haspopup": "menu",
                    "aria-expanded": isOpen,
                    role: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        })
                    ]
                });
            }
        }
    ]);
    return HamburgerMenuComponent;
}(react.PureComponent);
HamburgerMenuComponent.defaultProps = {
    changeStateCallback: function() {},
    isInScrollMode: false,
    theme: "",
    isOpen: false
};
/* harmony default export */ var hamburger_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(HamburgerMenuComponent));


/***/ }),

/***/ 25520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LongTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js + 1 modules
var base_footer_component = __webpack_require__(44574);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 57 modules
var base_template = __webpack_require__(81620);
// EXTERNAL MODULE: ./components/segments/index.js + 96 modules
var segments = __webpack_require__(91237);
;// CONCATENATED MODULE: ./components/segments/base-segment/base-segment-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var BaseSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseSegmentComponent);
    function BaseSegmentComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseSegmentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseSegmentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, segment = _props.segment, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps;
                var SegmentComponent = segments/* default */.Z[segment.type];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponent, _object_spread_props(_object_spread({}, extraProps, segment.props), {
                    isUserLoggedIn: isUserLoggedIn
                }));
            }
        }
    ]);
    return BaseSegmentComponent;
}(react.PureComponent);

BaseSegmentComponent.defaultProps = {
    extraProps: {}
};

// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 5 modules
var preview_base_segment_context = __webpack_require__(69132);
;// CONCATENATED MODULE: ./components/segments/segments-list/segments-list-component.js








var SegmentsListComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SegmentsListComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SegmentsListComponent);
    function SegmentsListComponent() {
        (0,_class_call_check/* default */.Z)(this, SegmentsListComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SegmentsListComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, segments = _props.segments, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps, isPreview = _props.isPreview;
                var Component = isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(BaseSegmentComponent) : BaseSegmentComponent;
                return segments.map(function(s, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        extraProps: extraProps,
                        segment: s,
                        isUserLoggedIn: isUserLoggedIn,
                        index: index
                    }, "".concat(s.type, "_").concat(index));
                });
            }
        }
    ]);
    return SegmentsListComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./constants/logo-themes.js
var LOGO_THEME_BLACK_COLOR = "black-color-theme";
var LOGO_THEME_BLACK = "black-theme";
var LOGO_THEME_LIGHT_COLOR = "light-color-theme";
var LOGO_THEME_LIGHT = "light-theme";

;// CONCATENATED MODULE: ./components/templates/long-template/long-template.js




function long_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function long_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            long_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function long_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function long_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        long_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var LongTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongTemplate);
    function LongTemplate() {
        (0,_class_call_check/* default */.Z)(this, LongTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig, isPreview = _props.isPreview;
                var segments = pageConfig.segments, topbar = pageConfig.topbar, footer = pageConfig.footer, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var preventMenu = topbar && topbar.preventMenu;
                var preventFooter = footer && footer.preventFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, long_template_object_spread_props(long_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            url: headerUrl,
                            loginTheme: pageConfig.loginTheme,
                            menuTheme: pageConfig.menuTheme,
                            logoTheme: LOGO_THEME_LIGHT_COLOR,
                            showMenu: !preventMenu,
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                            topBanner: topBanner,
                            maxWidth: "100%",
                            headerBackgroundColor: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            id: element_ids/* MAIN_ID */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentsListComponent, {
                                segments: segments,
                                isPreview: isPreview
                            })
                        }),
                        !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_footer_component["default"], {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return LongTemplate;
}(react.PureComponent);

LongTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75422);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__);









var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 58850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ LongTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_long_template_long_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25520);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var LongTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(LongTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(LongTemplatePage);
    function LongTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, LongTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(LongTemplatePage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, pageConfig = _props.pageConfig, errorCode = _props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_long_template_long_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return LongTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 53021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slim_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var SlimFooter = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var SLIM_FOOTER = "slim";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderSlimFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {
            pageClusterConfig: pageClusterConfig,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        var SlimFooterLinks = footerComponents.SlimFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: classnames_default()("footer-container", "slim-footer"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "categories-container",
                            children: SlimFooterLinks.map(function(column, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: column.type,
                                        links: column.links,
                                        hasMondayLogoTitle: index === 0
                                    })
                                });
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: SLIM_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderSlimFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var slim_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(SlimFooter)));
SlimFooter.defaultProps = default_props;


/***/ }),

/***/ 44574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ base_footer_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js + 1 modules
var slim_footer = __webpack_require__(53021);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/footer-consts.js
var footer_consts = __webpack_require__(99633);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/default-props.js
var default_props = __webpack_require__(96564);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.scss.js

var StyledBaseFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cyjyh50"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}






var BaseFooterComponent = function(props) {
    var _obj;
    var Footer = (_obj = {}, (0,_define_property/* default */.Z)(_obj, footer_consts/* LONG */.F, long_footer/* default */.Z), (0,_define_property/* default */.Z)(_obj, footer_consts/* SLIM */.z, slim_footer/* default */.Z), _obj)[props.footer_type] || slim_footer/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseFooterComponent, {
        className: "base-footer-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, _object_spread({}, props))
    });
};
BaseFooterComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var base_footer_component = (BaseFooterComponent);


/***/ }),

/***/ 96564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _footer_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99633);

/* harmony default export */ __webpack_exports__["Z"] = ({
    footer_type: _footer_consts__WEBPACK_IMPORTED_MODULE_0__/* .SLIM */ .z
});


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,6602,390,8559,5365,4778,677,9359,5990,2865,2300,7905,9173,5657,932,4494,4961,1068,3211,9952,516,1360,4303,1373,3203,8885,1620,6227,1882,4991,2719,8689,1241,4374,9774,2888,179], function() { return __webpack_exec__(83839); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);